import React from 'react'
import PropTypes from 'prop-types'

import GraphAlert from '../GraphAlert';
import CustomDialog from '../CustomDialog';


const MutationConfirmationDialog = ({
    title,
    children,
    isOpen,
    loading,
    error,
    handleClose,
    handleConfirm,
}) => (
    <CustomDialog
        open={isOpen}
        onClose={handleClose}
        title={title}
        cancelButtonText='Close'
        acceptButtonText='Confirm'
        loading={loading}
        handleConfirm={handleConfirm}
    >
        {!loading && <GraphAlert error={error} />}
        {children}
    </CustomDialog>
)


MutationConfirmationDialog.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    isOpen: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    error: PropTypes.object,
    handleClose: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired
}

MutationConfirmationDialog.defaultProps = {
    loading: false,
    error: null
}

export default MutationConfirmationDialog
